import React from 'react';

const VlendingLogo = () => {
  return (
    <div className={'vlending-logo-group'}>
      <figure className={'vlending-logo-link'}>
        <img fetchpriority='high' src='/images/logo_vlending.png' alt='Vlending Logo' className={'vlending-logo-img'} />
      </figure>
    </div>
  );
};

export default VlendingLogo;
